module.exports = "<highchart id=chart1 config=$ctrl.chartOptions></highchart>";


/*****************
 ** WEBPACK FOOTER
 ** ./app/hydromet/timeseriesNew/timeseries-new.html
 ** module id = 300
 ** module chunks = 0
 **/